import React from 'react';
import { Mail, Globe, Twitter } from 'lucide-react';

const ContactFooter = () => (
  <footer
    className="contact-footer mt-12 border-t border-gray-200 bg-gray-50"
    style={{
      paddingTop: '2rem',
      paddingBottom: 'calc(env(safe-area-inset-bottom) + 2rem)',
    }}
  >
    <div className="max-w-4xl mx-auto px-4">
      <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">Contact Us</h3>
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-8">
        <a
          href="mailto:mamo.studio93@gmail.com"
          className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
        >
          <Mail size={20} />
          <span className="text-sm">mamo.studio93@gmail.com</span>
        </a>
        <a
          href="https://coin.mmstudio.co.kr/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
        >
          <Globe size={20} />
          <span className="text-sm">https://coin.mmstudio.co.kr</span>
        </a>
        <a
          href="https://x.com/investing_sf"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-gray-700 hover:text-blue-600 transition-colors"
        >
          <Twitter size={20} />
          <span className="text-sm">@investing_sf</span>
        </a>
      </div>
      <p className="text-xs text-gray-500 text-center mt-6">
        © 2026 코인특공대. All rights reserved.
      </p>
    </div>
  </footer>
);

export default ContactFooter;
